import FakeInput from "@edaz/edazkit/controls/FakeInput";
import { formatBankAccount } from "@edaz/utils/bankAccount";
import type { ViewComponent } from "@frui.ts/views";
import { observer } from "mobx-react-lite";
import React from "react";
import { Col, Form } from "react-bootstrap";
import { formatAmount, formatDateTime } from "utils/localizations";
import type CustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/customerRefundCandidates/customerRefundCandidateDetailViewModel";
import type RejectedCustomerRefundCandidateDetailViewModel from "viewModels/finance/customerRefunds/rejectedCustomerRefundCandidates/rejectedCustomerRefundCandidateDetailViewModel";
import Section from "views/common/section";

const OriginalPayGatePaymentSection: ViewComponent<
  CustomerRefundCandidateDetailViewModel | RejectedCustomerRefundCandidateDetailViewModel
> = observer(({ vm }) => {
  const originalPayment = vm.item.originalPayGatePayment;

  return (
    <Section title={vm.translate("originalPayment")} context={originalPayment}>
      <Form.Row>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "paidAmount")}</Form.Label>
          <FakeInput target={originalPayment} property="paidAmount" valueFormatter={formatAmount} />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "variableSymbol")}</Form.Label>
          <FakeInput target={originalPayment} property="variableSymbol" />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "invoiceNumber")}</Form.Label>
          <FakeInput target={originalPayment} property="invoiceNumber" />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "authCode")}</Form.Label>
          <FakeInput target={originalPayment} property="authCode" />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "cardNumber")}</Form.Label>
          <FakeInput target={originalPayment} property="cardNumber" />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "authorizedAt")}</Form.Label>
          <FakeInput target={originalPayment} property="authorizedAt" valueFormatter={formatDateTime} />
        </Form.Group>
        <Form.Group as={Col}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "arn")}</Form.Label>
          <FakeInput target={originalPayment} property="arn" />
        </Form.Group>
      </Form.Row>
      <hr />
      <Form.Row>
        <Form.Group as={Col} sm={12}>
          <Form.Label>
            {vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "merchantBankAccount")}
          </Form.Label>
          <FakeInput target={originalPayment} property="merchantBankAccount" valueFormatter={formatBankAccount} />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "merchantId")}</Form.Label>
          <FakeInput target={originalPayment} property="merchantId" />
        </Form.Group>
        <Form.Group as={Col} md={6}>
          <Form.Label>{vm.translateSubAttribute("customerRefundCandidatePayGatePaymentResponse", "terminalId")}</Form.Label>
          <FakeInput target={originalPayment} property="terminalId" />
        </Form.Group>
      </Form.Row>
    </Section>
  );
});

export default OriginalPayGatePaymentSection;
